import type { ToolMeta } from './registry';

export const searchSupplierByNameMeta = {
  description: 'Looks up a specific wedding supplier by name across all categories.',
  examples: ['Tell me about Hedsor House', 'Look up The Savoy', 'Is Cliveden House on Bridebook?'],
  value: 'the detail on a named venue or supplier',
  grounding: 'venue',
} as const satisfies ToolMeta;
